import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Section from '../components/Section';
import {withRouter} from "react-router";
import RfxSupplierService from "services/RfxSupplierService";
import {connect} from "react-redux";
import Tr from "translations/Translations";
import Loading from "components/Loading";
import MoreButton from "components/button/MoreButton"
import ContractorTable from "components/complex/contractor/ContractorTable";
import AddContactor from "components/popup/addContactor/AddContactor";
import InviteContactor from 'components/popup/inviteContactor/InviteContactor';
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import {Typography} from "@material-ui/core";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "components/Dialog";
import useSearch, {getPaginationConfig} from "hooks/useSearch";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";

const useStyle = makeStyles((theme) => ({
    dropzone: {
        marginTop: theme.spacing(1)
    },
    buttonRow: {
        textAlign: "end"
    },
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
}));

function ContractorSection(
    {
        demandStatistics,
        currentRfxRound,
        match,
        supplier,
        rfxPrivileges,
        demandHeader
    }) {

    const classes = useStyle();
    const demandId = match.params.id;

    const [supplierLoading, setSupplierLoading] = useState(true);
    const [externalOfferSignConfirm, setExternalOfferSignConfirm] = useState([false, '']);
    const [invitePopup, setInvitePopup] = useState(false);
    const [addPopup, setAddPopup] = useState(false);

    const {searchData, totalCount, setTotalCount, setPaginationConfig} = useSearch();


    useEffect(() => {
        if (!!supplier && !!demandStatistics) {
            if (supplier.totalCount !== demandStatistics.numberOfSuppliers) {
                const loadedRows = supplier.items.length;
                const {pagination} = searchData;
                let curPageSize = loadedRows < pagination.pageSize ? pagination.pageSize : loadedRows;
                RfxSupplierService.getSuppliers(demandId, currentRfxRound.id, getPaginationConfig(1, curPageSize));
            }

        }
        // eslint-disable-next-line
    }, [demandStatistics])

    useEffect(() => {
        return () => RfxSupplierService.clearSuppliers()
    }, [demandId, currentRfxRound])


    useEffect(() => {
        if (currentRfxRound?.id) {
            setSupplierLoading(true);
            const {pagination} = searchData;
            RfxSupplierService.getSuppliers(demandId, currentRfxRound.id, pagination).then(() => (setSupplierLoading(false)));
        }
        // eslint-disable-next-line
    }, [searchData, currentRfxRound?.id])

    useDidUpdateEffect(() => {
        if (supplier?.totalCount !== undefined) {
            setTotalCount(supplier.totalCount)
        }
    }, [supplier?.totalCount]);

    const addContractorsTab = (data) => {
        setSupplierLoading(true);
        RfxSupplierService.add(demandId, currentRfxRound.id, data.platformAdded).then(() => {
            setPaginationConfig({...searchData.pagination, page: 1})
        });
        setAddPopup(false);
    }

    const handleExternalSign = (item) => {
        RfxSupplierService.changeExternalSign(demandId, currentRfxRound.id, item.id).then(response => {
            if (response != null)
                setExternalOfferSignConfirm([true, 'supplier_externalOfferSign_' + (response.externalOfferSign ? 'enabled' : 'disabled')]);
        });
    };

    const handleInvite = (values) => {
        setSupplierLoading(true);
        RfxSupplierService.invite(demandId, currentRfxRound.id, values).then(() => {
            setPaginationConfig({...searchData.pagination, page: 1})
        });
        setInvitePopup(false);
    };

    return (
        <div id="contractorSection">
            <Section
                title={Tr('contractors')}
            >
                {(!!supplier && !!currentRfxRound) &&
                <>
                    {!!rfxPrivileges.ADD_CONTRACTOR && !currentRfxRound.offerCollectionEnded &&
                    <GridBlock>
                        <Button
                            onClick={() => setAddPopup(true)}
                        >
                            {Tr('add_contractor')}
                        </Button>
                        <Button
                            className={classes.marginLeft}
                            onClick={() => setInvitePopup(true)}
                        >
                            {Tr('suggest_contractor')}
                        </Button>
                    </GridBlock>
                    }
                    <ContractorTable
                        contractors={supplier}
                        handleExternalSign={handleExternalSign}
                        showJoinDate={!!demandHeader.formType}
                    />

                    {supplierLoading && <Loading/>}

                    <MoreButton
                        config={searchData.pagination}
                        setConfig={setPaginationConfig}
                        totalCount={totalCount}
                        loadedCount={supplier.items.length}
                        captionTrKey='showing_x_of_y_suppliers'
                        disabled={supplierLoading || !(currentRfxRound && currentRfxRound.id)}
                    />

                    {invitePopup && <InviteContactor
                        demandId={demandId}
                        open
                        onClose={() => setInvitePopup(false)}
                        contractorList={supplier}
                        handleInvite={handleInvite}
                        collectPostCode
                        collectAddress
                        addressRequired={false}
                        collectCity
                        cityRequired={false}
                    />}
                    {addPopup && <AddContactor
                        demandId={match.params.id}
                        onClose={() => setAddPopup(false)}
                        addContractorsTab={addContractorsTab}
                    />}
                </>
                }
            </Section>

            <Dialog
                open={Boolean(externalOfferSignConfirm[0])}
            >
                <Typography>
                    {Tr(externalOfferSignConfirm[1])}
                </Typography>
                <div className={clsx(classes.buttonRow, classes.dropzone)}>
                    <Button
                        onClick={() => setExternalOfferSignConfirm(false)}
                    >
                        {Tr('close')}
                    </Button>
                </div>
            </Dialog>
        </div>
    )
}

ContractorSection.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    supplier: state.resources[RfxSupplierService.RESOURCE_ID]
}), {})(withRouter(ContractorSection));